module.exports = __webpack_public_path__ + "static/media/logo-latam.3e44b404.svg";